/**
 * Application configuration with environment-based switching
 */

const isDevelopment = import.meta.env.VITE_ENV === 'development';
const isProduction = import.meta.env.VITE_ENV === 'production';

export const config = {
  env: import.meta.env.VITE_ENV || 'development',
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  storageMode: (import.meta.env.VITE_STORAGE_MODE || 'localStorage') as 'localStorage' | 'cloudStorage',
  isDevelopment,
  isProduction,
  getStorageKey: (key: string) => `avocat_${key}`,
} as const;

export default config;
